import React from "react";
import Button from "../../atoms/Button/Button";
import ReactPlayer from "react-player";
import { getSignupUrl } from "../../../constants/urls";

const About: React.FC = () => {
  return (
    <div className="dui-about" id="about">
      <div className="dui-about-container">
        <div className="dui-about-content">
          <div className="dui-about-text">
            <h2 className="dui-about-heading">
              <span className="desktop-only">
                Pracujte bez obmedzení:
                <br />
                <span className="dui-about-heading-highlight">
                  Kompatibilita
                </span>{" "}
                naprieč zariadeniami a prehliadačmi
              </span>
              <span className="mobile-only">
                Pracujte{" "}
                <span className="dui-about-heading-highlight">
                  bez obmedzení
                </span>
              </span>
            </h2>
            <p className="dui-about-description">
              Náš systém je plne kompatibilný s počítačmi, tabletmi <br /> a
              viacerými webovými prehliadačmi (Chrome, Firefox, Edge), aby ste
              mohli pracovať efektívne kdekoľvek a kedykoľvek.
            </p>
            <div className="dui-about-stats">
              <div className="dui-about-stat">
                <h3 className="dui-about-stat-number">38%</h3>
                <p className="dui-about-stat-text">
                  Času ušetreného
                  <br />
                  pri písaní dekurzov
                </p>
              </div>
              <div className="dui-about-stat">
                <h3 className="dui-about-stat-number">3 dni</h3>
                <p className="dui-about-stat-text">
                  Dĺžka doby potrebná
                  <br />
                  na osvojenie softvéru
                </p>
              </div>
            </div>
            <Button
              className="dui-about-button"
              corners="rounded"
              onClick={() => {
                window.location.href = getSignupUrl();
              }}
            >
              Vyskúšať
            </Button>
          </div>
          <div className="dui-about-video">
            <div className="dui-about-video-container">
              <ReactPlayer
                url="https://www.youtube.com/watch?v=9O8Yd6y4L5I"
                width="100%"
                height="100%"
                controls={true}
                playing={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
